import React from 'react';
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import DeviceHubIcon from '@mui/icons-material/DeviceHub';
import { ReactComponent as HomeIcon } from '../../icons/iconsidebar_home.svg';
import { ReactComponent as DevicesIcon } from '../../icons/iconsidebar_devices.svg';
import { ReactComponent as ControlCenterIcon } from '../../icons/iconsidebar_control.svg';
import { ReactComponent as VehicleIcon } from '../../icons/vectorsidebar_vehicle.svg';
import { ReactComponent as RouteIcon } from '../../icons/iconsidebar_location.svg';
import { ReactComponent as TripIcon } from '../../icons/tripIcon.svg';
import { ReactComponent as UserIcon } from '../../icons/userIcon.svg';
import { ReactComponent as ActivityIcon } from '../../icons/activityIcon.svg';
import { URL_CONSTANT } from '../../URLConstants';

const sidebarConfig = [
  {
    title: 'Home',
    path: URL_CONSTANT.SMARTLOCK,
    icon: HomeIcon ? <HomeIcon sx={{ color: '#000000' }} /> : null,
    env: ['development', 'sandbox', 'production']
    // role: ['superadmin', 'admin']
  },
  {
    title: 'Trips',
    path: URL_CONSTANT.TRIP,
    icon: TripIcon ? <TripIcon /> : null,
    env: ['development', 'sandbox', 'production']
    // role: ['superadmin', 'admin']
  },
  {
    title: 'Devices',
    path: URL_CONSTANT.DEVICE,
    icon: DevicesIcon ? <DevicesIcon /> : null,
    env: ['development', 'sandbox', 'production']
    // role: ['superadmin', 'admin']
  },
  {
    title: 'Routes',
    path: URL_CONSTANT.ROUTES,
    icon: RouteIcon ? <RouteIcon /> : null,
    env: ['development', 'sandbox', 'production']
    // role: ['superadmin', 'admin']
  },
  {
    title: 'Vehicles',
    path: URL_CONSTANT.VEHICLE,
    icon: VehicleIcon ? <VehicleIcon /> : null,
    env: ['development', 'sandbox', 'production']
    // role: ['superadmin', 'admin']
  },
  {
    title: 'User Management',
    path: URL_CONSTANT.USERMANAGEMENT,
    icon: UserIcon ? <UserIcon /> : null,
    env: ['development', 'sandbox', 'production']
    // role: ['superadmin', 'admin']
  },
  {
    title: 'FOTA Logs',
    path: URL_CONSTANT.FOTALOGSMANAGEMENT,
    icon: UserIcon ? <DeviceHubIcon /> : null,
    env: ['development', 'sandbox', 'production'],
    role: ['superadmin']
  },
  {
    title: 'Activity Logs',
    path: URL_CONSTANT.ACTIVITYLOG,
    icon: ActivityIcon ? <ActivityIcon /> : null,
    env: ['development', 'sandbox', 'production'],
    role: ['superadmin']
  },
  {
    title: 'Control Center',
    path: URL_CONSTANT.CONTROLCENTER,
    icon: ControlCenterIcon ? <ControlCenterIcon /> : null,
    env: ['development', 'sandbox', 'production']
    // role: ['admin']
  },
  {
    title: 'Ticket Management',
    path: URL_CONSTANT.TICKETMANAGEMENT,
    icon: HelpOutlineOutlinedIcon ? <HelpOutlineOutlinedIcon /> : null,
    env: ['development', 'sandbox', 'production'],
    role: ['superadmin']
  }
];

export default sidebarConfig;
